// src/components/HeaderLogoBar.jsx
import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

function HeaderLogoBar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const contactNumber = "+923425262121";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        mb: 2,
        backgroundColor: "var(--secondary-color)",
        p: 0.5,
        borderRadius: "0 0 10px 10px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        position: "relative",
        minHeight: { xs: "30px", sm: "40px" },
        //border: "2px solid red", // Main container border
      }}
    >
      {/* Left Box: Logo - Fit to content */}
      <Box sx={{ 
        display: "flex", 
        alignItems: "center",
        justifyContent: "flex-start",
        flexShrink: 0, // Don't shrink, fit to content
        //border: "1px solid blue", // Left box border
        height: "100%",
        padding: "2px",
      }}>
        <Link to="/" className="logo-link">
          <Box
            component="img"
            src="/whiz-public/logo.png"
            alt="Company Logo"
            sx={{ 
              height: {
                xs: "30px",
                sm: "35px",  
                md: "55px",
              },
              width: "auto",
            }}
          />
        </Link>
      </Box>

      {/* Center Box: Brand Name - Take remaining space */}
      <Box sx={{ 
        display: "flex", 
        alignItems: "center",
        justifyContent: "center",
        flex: 1, // Take all available space
        minWidth: 0,
        //border: "1px solid green", // Center box border
        height: "100%",
        padding: "2px",
        mx: 2, // Add some margin between boxes
      }}>
        <Typography
          variant="h4"
          component={Link}
          to="/"
          sx={{
            color: "primary.main",
            fontWeight: "bold",
            textDecoration: "none",
            fontSize: { 
              xs: "1.5rem",
              sm: "1.75rem",  
              md: "2.0rem"  
            },
            '&:hover': {
              color: "var(--accent-color)",
              transition: "color 0.3s ease",
            },
            whiteSpace: "nowrap",
            textAlign: "center",
            lineHeight: 1,
          }}
        >
          Noor-un-Nikah
        </Typography>
      </Box>

      {/* Right Box: Contact and Login - Fit to content */}
      <Box sx={{ 
        display: "flex", 
        alignItems: "center",
        justifyContent: "flex-end",
        flexShrink: 0, // Don't shrink, fit to content
        //border: "1px solid orange", // Right box border
        height: "100%",
        padding: "2px",
      }}>
        {/* Contact Info (Visible on md and up) */}
        {!isMobile && (
          <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
            <IconButton
              sx={{ color: "primary.main" }}
              onClick={() => (window.location.href = `tel:${contactNumber}`)}
            >
              <PhoneIcon />
            </IconButton>
            <Typography
              sx={{
                color: "primary.main",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: { xs: "0.875rem", md: "1.5rem" },
              }}
            >
              {contactNumber}
            </Typography>
          </Box>
        )}

        {/* Login Button */}
        <IconButton
          component={Link}
          to="/login"
          size="small"
          sx={{
            padding: { xs: 0.5, sm: 0.75 }
          }}
        >
          <AccountCircleIcon sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }} />
        </IconButton>
      </Box>
    </Box>
  );
}

export default HeaderLogoBar;